import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractRefundPaymentEmailTemplate.List.IRequest;
type Response = Api.Core.ContractRefundPaymentEmailTemplate.List.IResponse;
type Headers = Api.Core.ContractRefundPaymentEmailTemplate.List.IHeaders;
const url = '/api/Management/ContractRefundPaymentEmailTemplate';
export default async function contractRefundPaymentEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
